export const PPLX_VISITOR_ID_COOKIE = 'pplx.visitor-id';
export const PPLX_SESSION_ID_COOKIE = 'pplx.session-id';
export const PPLX_VISITOR_FINGERPRINT_COOKIE = 'pplx.visitor-fp';
export const COMET_BROWSER_INFO_COOKIE = 'comet_browser';
export const PPLX_COLOR_SCHEME_COOKIE = 'colorScheme';
//# sourceMappingURL=constants.js.map